import React from 'react'
import PropTypes from 'prop-types'
import { StoreLocatorHaveResults, StoreLocatorNoResults } from './components'

const StoreLocatorSearchMain = ({ searchResults = [], ...props }) =>
  searchResults.length > 0 ?
    <StoreLocatorHaveResults { ...props } results={ searchResults } /> :
    <StoreLocatorNoResults { ...props } />

export default StoreLocatorSearchMain

StoreLocatorSearchMain.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.shape())
}
